"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SkeletonText = exports.SkeletonBox = exports.Skeleton = void 0;

var _themeGet = require("@styled-system/theme-get");

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styledSystem = require("styled-system");

var _splitProps = require("../../utils/splitProps");

var _Box = require("../Box");

var _Text = require("../Text");

var _excluded = ["children"],
    _excluded2 = ["children"];

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
/** A black10 Box */


var SkeletonBox = (0, _styledComponents.default)(_Box.Box).withConfig({
  displayName: "Skeleton__SkeletonBox",
  componentId: "sc-1vwqe5c-0"
})([""]);
exports.SkeletonBox = SkeletonBox;
SkeletonBox.defaultProps = {
  bg: "black10"
};
var splitBorderProps = (0, _splitProps.splitProps)(_styledSystem.border);
/** SkeletonTextProps */

var SkeletonTextOverlay = (0, _styledComponents.default)(SkeletonBox).withConfig({
  displayName: "Skeleton__SkeletonTextOverlay",
  componentId: "sc-1vwqe5c-1"
})(["position:absolute;top:50%;left:0;width:100%;height:calc(100% - 0.25em);transform:translateY(-50%);"]);
/**
 * Allows you to create boxes the exact dimensions of a given piece of text
 */

var SkeletonText = function SkeletonText(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _splitBorderProps = splitBorderProps(rest),
      _splitBorderProps2 = _slicedToArray(_splitBorderProps, 2),
      borderProps = _splitBorderProps2[0],
      textProps = _splitBorderProps2[1];

  return /*#__PURE__*/_react.default.createElement(_Text.Text, _extends({
    color: "transparent"
  }, textProps), /*#__PURE__*/_react.default.createElement(_Box.Box, {
    as: "span",
    display: "inline-flex",
    position: "relative",
    "aria-hidden": true
  }, children, /*#__PURE__*/_react.default.createElement(SkeletonTextOverlay, borderProps)));
};

exports.SkeletonText = SkeletonText;
SkeletonText.displayName = "SkeletonText";
var FADE_ANIMATION = (0, _styledComponents.keyframes)(["0%{opacity:0.5;}50%{opacity:0;}100%{opacity:0.5;}"]);
var SkeletonFade = (0, _styledComponents.default)(_Box.Box).withConfig({
  displayName: "Skeleton__SkeletonFade",
  componentId: "sc-1vwqe5c-2"
})(["background-color:", ";animation:", " 2s ease-in-out infinite;"], (0, _themeGet.themeGet)("colors.white100"), FADE_ANIMATION);
/**
 * Animated wrapper for Skeletons
 */

var Skeleton = function Skeleton(_ref2) {
  var children = _ref2.children,
      rest = _objectWithoutProperties(_ref2, _excluded2);

  return /*#__PURE__*/_react.default.createElement(_Box.Box, _extends({
    position: "relative"
  }, rest), children, /*#__PURE__*/_react.default.createElement(SkeletonFade, {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  }));
};

exports.Skeleton = Skeleton;
Skeleton.displayName = "Skeleton";